module.exports = __webpack_public_path__ + "img/kv_herobanner-1.7ccea51c.jpg";